/**
 * AnonymousApp
 * Could be apart of the core platform containers as it could be reused for other apps, but have kept it seperate
 * while insights is in alpha.
 *
 * It's role is to delay showing the page until the tenant has been validated and settings returned
 *
 * @author Matthew Rawson @ 07/02/2018 15:01
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {NavHeader} from "../../components/NavHeader"

/**
 * Extending global css
 */
const Main = styled(({className, children}) => <div className={`${className} main`}>{children}</div>)`
  min-height: calc(100vh - 70px);
  padding-bottom: 0;

  overflow-x: hidden;
`

/**
 * AnonymousContainer
 */
class AnonymousContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  }

  render() {
    return (
      <>
        <NavHeader />
        <Main>{this.props.children}</Main>
      </>
    )
  }
}

export default AnonymousContainer
